export default __webpack_public_path__ + "static/media/Linda_Inlay_AHV_In_Moms_We_Trust.ef806eb7.jpg";